<template>
  <div class="content">
    <div class="content-wrapper">
      <FloorCardList :floors="floors"/>
      <MediaPlayer />
      <Info />
    </div>
  </div>
</template>

<script>
import FloorCardList from './FloorCardList.vue';
import MediaPlayer from './mediaPlayer/MediaPlayer.vue';
import Info from './Info.vue';

export default {
  name: 'theContent',
  components: {
    FloorCardList,
    MediaPlayer,
    Info,
  },
  props: {
    floors: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
.content{
  position: absolute;
  margin-top: 14vh;
  margin-top: calc(var(--vh, 1vh) * 14);
  overflow: hidden;
  width: 100vw;
  height: 77vh;
  height: calc(var(--vh, 1vh) * 77);
}
.content-wrapper {
  position: relative;
  width: 100vw;
}
@media only screen and (orientation : portrait)
 and (min-aspect-ratio: 4/9)
 and (max-height : 700px) {
  .content{
  }
}
@media only screen and (orientation : landscape) {
}
</style>
